var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('error-dialog', {
    attrs: {
      "status": _vm.loadStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.saveContactStatus
    }
  }), _c('error-dialog', {
    attrs: {
      "status": _vm.deleteContactStatus
    }
  }), _vm.showAddField ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "300"
    },
    model: {
      value: _vm.showAddField,
      callback: function ($$v) {
        _vm.showAddField = $$v;
      },
      expression: "showAddField"
    }
  }, [_c('v-card', [_c('div', {
    staticClass: "pt-3 px-3"
  }, [_c('v-form', {
    model: {
      value: _vm.isNewFieldNameValid,
      callback: function ($$v) {
        _vm.isNewFieldNameValid = $$v;
      },
      expression: "isNewFieldNameValid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Field name",
      "persistent-placeholder": "",
      "placeholder": "",
      "rules": [function (v) {
        return !!v && (_vm.fields.find(function (x) {
          return x.key == v;
        }) ? 'Field already exists' : true);
      }]
    },
    model: {
      value: _vm.newFieldName,
      callback: function ($$v) {
        _vm.newFieldName = $$v;
      },
      expression: "newFieldName"
    }
  })], 1)], 1), _c('v-card-actions', {
    staticClass: "px-3"
  }, [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.showAddField = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.isNewFieldNameValid
    },
    on: {
      "click": function ($event) {
        _vm.fields.push({
          key: _vm.newFieldName,
          type: _vm.newFieldName == 'address' ? 'address' : 'text'
        });
        _vm.newFieldName = '';
        _vm.showAddField = false;
      }
    }
  }, [_vm._v(" Add ")])], 1)], 1)], 1) : _vm._e(), _vm.selected ? _c('dialog-scroll-lock', {
    attrs: {
      "width": "400",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', [_c('v-btn', {
    staticClass: "float-right ma-3",
    attrs: {
      "icon": ""
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiClose)
    }
  })], 1), _c('v-card-title', [_vm.selected.id ? [_vm._v("Contact")] : [_vm._v("Add contact")]], 2), _c('v-divider'), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _c('div', {
    staticClass: "pl-3 pl-sm-6 pr-2 pr-sm-3 pt-3 pb-1"
  }, _vm._l(_vm.fields, function (field, i) {
    return _c('div', {
      staticClass: "py-3"
    }, [_c('div', {
      staticClass: "text--label-active"
    }, [_vm._v(_vm._s(field.key))]), _c({
      address: 'ContactFieldAddress',
      date: 'ContactFieldDate',
      'phone number': 'ContactFieldPhone'
    }[field.type] || 'VTextField', {
      tag: "component",
      staticClass: "mt-0 flex-no-wrap",
      attrs: {
        "dense": "",
        "hide-details": "",
        "disabled": _vm.saveContactStatus.pending,
        "value": _vm.selected.contact[field.key]
      },
      on: {
        "input": function (v) {
          return _vm.$set(_vm.selected.contact, field.key, v);
        }
      },
      scopedSlots: _vm._u([{
        key: "append-outer",
        fn: function () {
          return [_c('v-menu', {
            attrs: {
              "bottom": "",
              "offset-y": ""
            },
            scopedSlots: _vm._u([{
              key: "activator",
              fn: function (_ref) {
                var on = _ref.on,
                  attrs = _ref.attrs;
                return [_c('v-btn', _vm._g(_vm._b({
                  directives: [{
                    name: "blur",
                    rawName: "v-blur"
                  }],
                  staticClass: "px-0",
                  attrs: {
                    "text": "",
                    "x-small": ""
                  }
                }, 'v-btn', attrs, false), on), [_c('v-icon', {
                  attrs: {
                    "small": ""
                  },
                  domProps: {
                    "innerHTML": _vm._s(_vm.SEARCH_FIELD_TYPES[field.type])
                  }
                }), _c('v-icon', {
                  attrs: {
                    "small": ""
                  },
                  domProps: {
                    "innerHTML": _vm._s(_vm.mdiMenuDown)
                  }
                })], 1)];
              }
            }], null, true)
          }, [_c('v-list', {
            attrs: {
              "dense": ""
            }
          }, _vm._l(_vm.SEARCH_FIELD_TYPES, function (icon, type) {
            return _c('v-list-item', {
              key: type,
              staticClass: "overline short",
              attrs: {
                "input-value": field.type == type,
                "disabled": field.type != type && ['name', 'email', 'phone', 'birthday', 'address'].includes(field.key)
              },
              on: {
                "click": function ($event) {
                  field.type = type;
                }
              }
            }, [_c('v-icon', {
              staticClass: "mr-2",
              domProps: {
                "innerHTML": _vm._s(icon)
              }
            }), _vm._v(" " + _vm._s(type) + " ")], 1);
          }), 1)], 1)];
        },
        proxy: true
      }], null, true)
    })], 1);
  }), 0), _c('div', {
    staticClass: "d-flex pb-3 px-3"
  }, [_c('v-btn', {
    staticClass: "text--label-active",
    staticStyle: {
      "text-transform": "unset",
      "letter-spacing": "unset"
    },
    attrs: {
      "text": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.showAddField = true;
      }
    }
  }, [_c('span', [_vm._v("Add field…")])])], 1), _c('v-divider'), _c('v-card-actions', {
    staticClass: "px-3"
  }, [_vm.selected.id ? _c('v-btn', {
    staticClass: "px-2",
    staticStyle: {
      "min-width": "unset"
    },
    attrs: {
      "loading": _vm.deleteContactStatus.pending
    },
    on: {
      "click": _vm.deleteContact
    }
  }, [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s(_vm.mdiDelete)
    }
  })], 1) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v(_vm._s(_vm.selected.id && !_vm.isSelectedDirty ? 'Close' : 'Cancel'))]), _c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.isSelectedDirty,
      "loading": _vm.saveContactStatus.pending
    },
    on: {
      "click": _vm.saveContact
    }
  }, [_vm._v(" Save ")])], 1)], 1)], 1) : _vm._e(), _c('v-data-table', {
    staticClass: "overflow-visible no-header",
    attrs: {
      "must-sort": "",
      "mobile-breakpoint": "0",
      "server-items-length": _vm.n,
      "options": _vm.options,
      "footer-props": {
        disableItemsPerPage: true,
        itemsPerPageOptions: [_vm.options.itemsPerPage]
      },
      "headers": _vm.HEADERS,
      "items": _vm.rows,
      "loading": _vm.loadStatus.pending
    },
    on: {
      "update:options": function ($event) {
        _vm.options = $event;
      },
      "click:row": _vm.select
    },
    scopedSlots: _vm._u([{
      key: "item.default",
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_vm._t("item", function () {
          return [_c('div', {
            staticClass: "py-2 d-flex align-center"
          }, [_vm._t("item-prefix", null, null, {
            item
          }), _c('div', [item.contact.name ? _c('div', [_vm._v(_vm._s(_vm.getKey(item.contact)))]) : _c('div', [_vm._v("–")]), !item.contact.email && !item.contact.phone ? _c('div', {
            staticClass: "caption error--text"
          }, [_vm._v(" No phone number / email address ")]) : _vm._e(), _vm._t("item-targets", function () {
            return [item.contact.email ? _c('span', {
              staticClass: "target caption grey--text"
            }, [_vm._v(_vm._s(item.contact.email))]) : _vm._e(), item.contact.phone ? _c('span', {
              staticClass: "target caption grey--text"
            }, [_vm._v(_vm._s(_vm._f("phone")(item.contact.phone)))]) : _vm._e()];
          }, null, {
            item
          })], 2)], 2)];
        }, null, {
          item
        })];
      }
    }], null, true)
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }